import React from 'react'
import { Route, IndexRoute } from 'react-router'

import App from './containers/app'
import DataPage from './containers/data-page'
import DraftsPage from './containers/drafts-page'
import EventGroupPage from './containers/event-group-page'
import EventGroupHomePage from './containers/event-group-home-page'
import EventGroupDetailsPage from './containers/event-group-details-page'
import EventGroupIntegrationsPage from './containers/event-group-integrations-page'
import EventGroupGridPage from './containers/event-group-grid-page'
import HomePage from './containers/home-page'
import IframePage from './containers/iframe-page'
import PerformancePage from './containers/performance-page'
import SetupformPage from './containers/setupform-page'
import SetupformDetailsPage from './containers/setupform-details-page'
import SetupformVouchersPage from './containers/setupform-vouchers-page'
import SetupformSummaryPage from './containers/setupform-summary-page'
import DatesPage from './containers/dates-page'
import Styleguide from './containers/styleguide'
import Ticketing from './containers/ticketing-page'
import PromoCodePage from './containers/promo-code-page'
import { CONTENT_GROUP } from './constants/analytics-constants'

export default (
  <Route path="/">
    <Route component={App} path="p/:partnerId">
      <IndexRoute component={HomePage} contentGroup={CONTENT_GROUP.HOMEPAGE} />
      <Route component={DraftsPage} path="drafts" />
      <Route component={DataPage} path="data" />
      <Route component={PromoCodePage} path="promo-code" />
      <Route component={PerformancePage} path="performance/:performanceId" contentGroup={CONTENT_GROUP.PERFORMANCES} />

      <Route path="sf/:setupformId">
        <IndexRoute component={SetupformPage} isFullPage />
        <Route component={SetupformDetailsPage} path="details" isFullPage />
        <Route component={SetupformSummaryPage} path="summary" isFullPage />
        <Route component={SetupformVouchersPage} path="vouchers" isFullPage />
      </Route>

      <Route component={DatesPage} path="dates" />

      <Route path="event/:eventGroupId" component={EventGroupPage}>
        <IndexRoute component={EventGroupHomePage} contentGroup={CONTENT_GROUP.EVENTGROUPS} />
        <Route path="details" component={EventGroupDetailsPage} />
        <Route path="integrations" component={EventGroupIntegrationsPage} />
      </Route>
      <Route path="event/:eventGroupId/grid" component={EventGroupGridPage} isFullPage />

      {/* Old Iframed performance pages (under old event url) */}
      <Route component={IframePage} path="event/:eventGroupId/history" />

      {/* Old Iframed pages */}
      <Route component={IframePage} path="payments" />
      <Route component={IframePage} path="settings" />
      <Route component={IframePage} path="page_config" />
    </Route>
    <Route component={Styleguide} path="styleguide" />
    <Route component={Ticketing} path="ticketing" />
  </Route>
)



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/